<template>
  <div class="d-flex justify-start align-center mt-1">
    <BaseActionsButton
      id="viewDetailsVehicle"
      name="viewDetailsVehicle"
      iconName="mdi-eye"
      iconColor="primary"
      customClass="mr-2"
      tooltipMessage="View Details"
      @click="viewDetails()"
    ></BaseActionsButton>
    <BaseActionsButton
      id="editVehicle"
      name="editVehicle"
      iconName="mdi-pencil"
      iconColor="primary"
      customClass="mr-2"
      tooltipMessage="Edit Details"
      @click="editVehicle()"
    ></BaseActionsButton>
  </div>
</template>

<script>
export default {
  methods: {
    editVehicle() {
      this.params.context.parentComponent.editVehicle(this.params.data.id);
    },
    viewDetails() {
      this.params.context.parentComponent.viewDetails(this.params.data.id);
    },
  },
};
</script>

<style>
</style>